import {
  getSortDefectenOptions,
  SorteringRichting,
  type SorteringType,
} from '@/components/sidebar/sortField/useSorting';
import type { BronType, DefectSoort, DefectStatus } from '@/types/Defecten';

const sortDefectenOptions = getSortDefectenOptions();
const defaultSortType = sortDefectenOptions[0];
const defaultValueSortDirection = SorteringRichting.UP;

export type DefectenFilter = {
  eenheidnummer?: string;
  materieelTypen?: string[];
  defectSoorten?: DefectSoort[];
  defectStatussen?: DefectStatus[];
  defectBronnen?: BronType[];
  sorteringType?: SorteringType;
  sorteringRichting?: SorteringRichting;
};

export const defaultFilter = {
  sorteringType: defaultSortType.value,
  sorteringRichting: defaultValueSortDirection,
} satisfies DefectenFilter;
